import { ref } from "vue";

const showNewsletterDialog = ref(false);

export function useNewsletterDialog() {
  return { showNewsletterDialog };
}
